import { REPORT_CONFIGS } from './reportConfig';
import ReportSummary from './components/ReportSummary';
import { dashboardListClasses, dashboardTitleClasses } from '../../../components/common/dashboardClasses';
import SuperAdminPageWrapper from '../components/SuperAdminPageWrapper';

const Reports = () => {
  return (
    <SuperAdminPageWrapper>
      <div className={`container ${dashboardListClasses}`}>
        <h1 className={`${dashboardTitleClasses} mb-6`}>Reports</h1>
        {REPORT_CONFIGS.map((config) => (
          <ReportSummary  key={config.csvType} config={config}/>
        ))}
      </div>
    </SuperAdminPageWrapper>
  );
};

export default Reports;